module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginbg"
    }
  }, [_vm._v("  ·\n  "), _c('div', {
    attrs: {
      "id": "ding"
    }
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "id": "wenzi"
    }
  }, [_vm._v("\n      自提系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "zhanghao"
    }
  }, [_vm._v("\n      账号\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "tuichu"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n      【退出】\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "id": "yuyue"
    },
    on: {
      "click": _vm.chakan
    }
  }, [_vm._v("\n      查看商品\n    ")])]), _vm._v(" "), _c('el-form', {
    ref: "resform",
    attrs: {
      "model": _vm.resform,
      "id": "products1",
      "rules": _vm.rules3,
      "label-width": "100px"
    }
  }, [_c('div', {
    attrs: {
      "id": "lujingkongzhi"
    }
  }, [_c('img', {
    attrs: {
      "id": "lujing",
      "src": require("../../assets/信息填写.png")
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "提货卡卡号:"
    }
  }, [_c('el-row', {
    attrs: {
      "onfocus": "this.blur()"
    }
  }, [_vm._v(_vm._s(this.$route.query.card))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "收件人姓名:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.resform.name),
      callback: function($$v) {
        _vm.$set(_vm.resform, "name", $$v)
      },
      expression: "resform.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "收件人电话:",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.resform.phone),
      callback: function($$v) {
        _vm.$set(_vm.resform, "phone", $$v)
      },
      expression: "resform.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "验证码:",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.resform.code),
      callback: function($$v) {
        _vm.$set(_vm.resform, "code", $$v)
      },
      expression: "resform.code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "left": "323px",
      "top": "6px",
      "width": "100px"
    },
    attrs: {
      "id": "code",
      "type": "primary",
      "size": "mini",
      "disabled": _vm.codeDisabled
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.codeMsg))])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "地址:",
      "prop": "address"
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.resform.province,
      "city": _vm.resform.city,
      "area": _vm.resform.area
    },
    on: {
      "province": _vm.provinceChange,
      "city": _vm.cityChange,
      "area": _vm.areaChange
    },
    model: {
      value: (_vm.resform.address),
      callback: function($$v) {
        _vm.$set(_vm.resform, "address", $$v)
      },
      expression: "resform.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "详细地址:",
      "prop": "detailAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.resform.detailAddress),
      callback: function($$v) {
        _vm.$set(_vm.resform, "detailAddress", $$v)
      },
      expression: "resform.detailAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "label": "发货时间:",
      "prop": "appointmentTime"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.resform.appointmentTime),
      callback: function($$v) {
        _vm.$set(_vm.resform, "appointmentTime", $$v)
      },
      expression: "resform.appointmentTime"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-left": "-30px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.resLoading
    },
    on: {
      "click": _vm.reservationSave
    }
  }, [_vm._v("预约")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#eaeaea",
      "width": "570px",
      "height": "65px",
      "border-radius": "7px"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "645px",
      "width": "500px",
      "margin-left": "40px"
    }
  }, [_vm._v("\n        提示：快递公司收件后正常情况下可以当天发出。一般快递公司正常每天装包发车的时间为下午四点，在装包发车时间之前被快递员收取的快递，当天都可以正常发出。请用户合理安排时间。\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-563ca6b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cdwgkj/ReservationOrder.vue
// module id = 597
// module chunks = 1